import {post, get} from '@/lib/axios';

const live_news = {
  async get_live_news() {
    return get(`/feed`);
  },
  async post_live_news(data) {
    return post(`/feed`, data);
  },
};

export {live_news as default};
